module.exports = __webpack_public_path__ + "img/2-Intersection 2.5e521837.png";